import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import MessageCard from '../MessageCard'
import { RequestOrderMessage } from '~/src/repositories/Order/models/Order'
import { SimpleDialog } from '~/src/components/organisms/SimpleDialog/SimpleDialog'
import { UnreadLine } from '~/src/components/atoms/UnreadLine'

interface IMessageListProps {
  id: string
  messages: RequestOrderMessage[]
  isLoading: boolean
  onDeleteMessage: (execeute: boolean, commentId: number) => void
}

export const MessageList: React.FC<IMessageListProps> = ({ id, messages, isLoading, onDeleteMessage }) => {
  const { t } = useTranslation()
  const [showDialog, setShowDialog] = useState(false)
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [buttonTextOk, setButtonTextOk] = useState('')
  const [buttonTextNo, setButtonTextNo] = useState('')
  const [okButtonColor, setOkButtonColor] = useState('')
  const [commentId, setCommentId] = useState(0)

  const handleClose = async (execute = false) => {
    setShowDialog(false)
    onDeleteMessage(execute, commentId)
  }
  const deleteComment = async (commentId: number, title: string, message: string, buttonTextOk: string, buttonTextNo: string, okButtonColor: string) => {
    setTitle(title)
    setMessage(message)
    setButtonTextOk(buttonTextOk)
    setButtonTextNo(buttonTextNo)
    setOkButtonColor(okButtonColor)
    setCommentId(commentId)
    setShowDialog(true)
  }

  // メッセージをidの昇順(古い順)にし、一番最初の未読メッセージのindexを取得する
  messages.sort((current, next) => current.id - next.id)
  const index = messages.findIndex((message) => message.isUnread === true);

  // column-reverseで表示するため、並び順を元に戻す
  messages.sort((current, next) => next.id - current.id)

  // 未読メッセージと既読メッセージを分ける
  // index が -1 の場合は未読メッセージが存在しない = メッセージが0件 or 既読メッセージしかない
  const messagesLength = messages.length;
  let unreadMessages: RequestOrderMessage[] = [];
  let readMessages: RequestOrderMessage[] = [];
  if (messagesLength !== 0) {
    if (index === -1) {
      readMessages = messages;
    } else {
      unreadMessages = messages.slice(0, messagesLength - index);
      readMessages = messages.slice(messagesLength - index);
    }
  }

  return (
    <>
      <Typography
        variant={'h2'}
        sx={{
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          padding: '16px',
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '20px',
          lineHeight: '32px',
          letterSpacing: '0.15px',
          color: 'rgba(0, 0, 0, 1)',
        }}
      >
        {t('contact_order_detail.negotiation_details')}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column-reverse', //スクロールの初期位置を最下部にするため
          overflow: 'auto',
          maxHeight: 500,  
        }}
      >
        { !!unreadMessages.length && (
        <>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column-reverse', //スクロールの初期位置を最下部にするため
            }}>
            <MessageCard
              id={id}
              messages={unreadMessages}
              isLoading={isLoading}
              isShowAll={true}
              onDelete={deleteComment}
            />
            <SimpleDialog open={showDialog} title={title} message={message} buttonTextOk={buttonTextOk} buttonTextNo={buttonTextNo} handleClose={handleClose} />
          </Box>
          <UnreadLine />
        </>
        )}
        { !!readMessages.length && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column-reverse', //スクロールの初期位置を最下部にするため
              '& .MuiBox-root:first-of-type': {
                borderBottom: 'none',
              }
            }}>
            <MessageCard
              id={id}
              messages={readMessages}
              isLoading={isLoading}
              isShowAll={true}
              onDelete={deleteComment}
            />
            <SimpleDialog open={showDialog} title={title} message={message} buttonTextOk={buttonTextOk} buttonTextNo={buttonTextNo} handleClose={handleClose} />
          </Box>
        )}
        { !readMessages.length && !unreadMessages.length && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column-reverse', //スクロールの初期位置を最下部にするため
            }}>
            <MessageCard
              id={id}
              messages={messages}
              isLoading={isLoading}
              isShowAll={true}
              onDelete={deleteComment}
            />
            <SimpleDialog open={showDialog} title={title} message={message} buttonTextOk={buttonTextOk} buttonTextNo={buttonTextNo} handleClose={handleClose} />
          </Box>
        )}
      </Box>
    </>
  )
}
